// eslint-disable-next-line import/no-cycle
import {
  numberLogicalOperators,
  selectionBasedIDLogicalOperators,
  stringLogicalOperators,
} from '@/composables/segmentations/logicalOperators';
// eslint-disable-next-line import/no-cycle
import {
  getProductCategoriesPropertiesSegments,
  getProductManufacturersPropertiesSegments,
  getProductCombinationsPropertiesSegments,
} from '@/composables/segmentations/themes/common-segments/productPropertiesSegment';

/**
 * Get the current product properties segments for navigation context
 * These segments are evaluated against the current page's product context
 */
export const getCurrentProductPropertiesSegments = async (includeContext = false) => {
  const productCategories = await getProductCategoriesPropertiesSegments();
  const productManufacturers = await getProductManufacturersPropertiesSegments();
  const productCombinations = await getProductCombinationsPropertiesSegments();

  return [
    {
      id: 'id',
      label: 'segmentations.navigation.currentProduct.id',
      logical_operators: selectionBasedIDLogicalOperators('id'),
      ...(includeContext && { context: 'navigation.currentProduct.id' }),
    },
    {
      id: 'name',
      label: 'segmentations.navigation.currentProduct.name',
      logical_operators: stringLogicalOperators('name'),
      ...(includeContext && { context: 'navigation.currentProduct.name' }),
    },
    {
      id: 'price',
      label: 'segmentations.navigation.currentProduct.price',
      logical_operators: numberLogicalOperators('price'),
      hasCurrency: true,
      ...(includeContext && { context: 'navigation.currentProduct.price' }),
    },
    {
      id: 'price_discount',
      label: 'segmentations.navigation.currentProduct.priceDiscount',
      logical_operators: numberLogicalOperators('price_discount'),
      hasCurrency: true,
      ...(includeContext && { context: 'navigation.currentProduct.price_discount' }),
    },
    {
      id: 'quantity',
      label: 'segmentations.navigation.currentProduct.quantity',
      logical_operators: numberLogicalOperators('quantity'),
      ...(includeContext && { context: 'navigation.currentProduct.quantity' }),
    },
    {
      id: 'categories',
      label: 'segmentations.navigation.currentProduct.categories',
      sub_properties: productCategories,
      multiple: true,
    },
    {
      id: 'manufacturer',
      label: 'segmentations.navigation.currentProduct.manufacturer',
      sub_properties: productManufacturers,
    },
    {
      id: 'combinations',
      label: 'segmentations.navigation.currentProduct.combinations',
      sub_properties: productCombinations,
    },
  ];
};

export default getCurrentProductPropertiesSegments;
